



































import Modal from "../../core/Modals/Modal.vue";
import EmployeSelect from "../../core/Forms/EmployeSelect.vue";
import { InterventionApi } from "../../api/InterventionApi";
import { Intervention } from "../../models/Intervention";

export default {
    name: "InterventionControlEdit",
    components: { EmployeSelect, Modal },
    props: {
        interventions: Array,
    },
    data() {
        return {
            showModal: true,
            saving: false,
            selectedControleur: null,
            InterventionApi: new InterventionApi(),
        };
    },
    methods: {
        closeModal: function (): void {
            this.$emit("close-modal");
        },
        saveData: function (): void {
            let self = this;
            let promises = [];

            if (self.saving) {
                return;
            }

            self.saving = true;

            _.forEach(self.interventions, function (src) {
                let source = new Intervention(src);
                let controle = new Intervention({
                    client_id: source.client_id,
                    date_prevue_intervention: source.date_prevue_intervention,
                    horaire_debut: source.horaire_fin || source.horaire_debut,
                    duree_prevue: 0.5,
                    controle: true,
                    titre: "Contrôle - " + (source.titre || ""),
                });
                controle.updateHoraireFin();
                controle.employes = self.selectedControleur
                    ? [self.selectedControleur]
                    : [];
                promises.push(self.InterventionApi.save(controle));
            });
            Promise.all(promises).then(function () {
                self.closeModal();
            });
        },
    },
};
